import React, { useEffect, useState, useMemo, useRef } from "react";
import { Select, Spin } from "antd";
import { debounce } from "lodash";

const { Option } = Select;

const TagSelect = ({
    value = [],
    onChange,
    fetchTags,      // function(page, search)
    userTagOptions, // initial user tags
}) => {

    const [tagList, setTagList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const scrollPosRef = useRef(0);
    const listRef = useRef(null);
    const limit = 10

    const fetchTagsAPI = async (pageNo = 0, search = "") => {
        try {
            setLoading(true);
            const all_tags = await fetchTags(pageNo, search, limit)
            const data = all_tags || [];
            setTagList((prev) => {
                const merged = [...prev, ...data];
                const unique = Array.from(new Map(merged.map(t => [t.value, t])).values());
                return unique;
            });
            setHasMore(data.length > 0);
        } catch (err) {
            console.log("failed to fetch master tag")
        } finally {
            // setLoading(false);
            setTimeout(() => setLoading(false), 300);
        }
    };

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight} = e.target;
        scrollPosRef.current = scrollTop; // store scroll position
        if (scrollHeight - scrollTop - clientHeight < 5 && hasMore && !loading) {
            const nextPage = page + 1;
            setPage(nextPage);
            fetchTagsAPI(nextPage);
        }
    };

    const debouncedSearch = useMemo(
        () =>
            debounce((val) => {
                setPage(0);
                fetchTagsAPI(0, val);
            }, 500),
        []
    );

    useEffect(() => {
        setPage(0);
        fetchTagsAPI(0);
    }, []);

    // Initial load
    useEffect(() => {
        console.log(userTagOptions)
        setTagList((prev) => {
            const merged = [...prev, ...userTagOptions];
            const unique = Array.from(new Map(merged.map(t => [t.value, t])).values());
            return unique;
        });
    }, [userTagOptions]);

    useEffect(() => {
        const dropdownList = listRef.current?.querySelector(".ant-select-item-option-content")?.parentElement?.parentElement;
        if (dropdownList) {
            dropdownList.scrollTop = scrollPosRef.current;
        }
    }, [tagList]);

    return (
        <Select
            mode="multiple"
            showSearch
            placeholder="Search and select tags"
            value={value}
            onChange={onChange}
            onSearch={debouncedSearch}
            onPopupScroll={handleScroll}
            listHeight={limit*20} 
            filterOption={false}
            loading={loading}
            allowClear
            style={{ width: "100%" }}
            dropdownRender={(menu) => (
                <div ref={listRef}>
                {menu}
                {loading && (
                    <div className="flex justify-center py-2 text-gray-500">
                    <Spin size="small" />
                    <span style={{ marginLeft: 8 }}>Loading...</span>
                    </div>
                )}
                </div>
            )}
        >
            {tagList.map((tag) => (
                <Option key={tag.value} value={tag.value}>
                    {tag.label}
                </Option>
            ))}
        </Select>
    )

}

export default TagSelect;